import { render, staticRenderFns } from "./AdminStandardExport.vue?vue&type=template&id=21c8bd84"
import script from "./AdminStandardExport.vue?vue&type=script&lang=js"
export * from "./AdminStandardExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports